import { Typography } from '@mui/material';
import { TExistingUploadedFile, DocumentRequirementsList } from '@verifime/components';
import DocumentsUploader from '../DocumentsUploader/DocumentsUploader';
import {
  DOCUMENT_REQUIREMENTS_INTRO,
  ADDITIONAL_DOCUMENTS_HEADING,
  ADDITIONAL_DOCUMENTS,
} from './constants';
import { useDocumentRequirements } from './hooks';
import type { TOrganisationEntityType } from './constants';

export type TOrganisationEntityDocumentsUploaderProps = {
  entityId: string;
  entityType: TOrganisationEntityType;
  onUploadingChange?: (isUploading: boolean) => void;
  onUploadedFilesChange?: (files: TExistingUploadedFile[]) => void;
};

/**
 * View component that provides entity-specific document requirements to DocumentsUploader.
 *
 * Uses useDocumentRequirements hook to get document requirements.
 * Hook currently returns hardcoded data but will be replaced with API call in future.
 */
export default function OrganisationEntityDocumentsUploader({
  entityId,
  entityType,
  onUploadingChange,
  onUploadedFilesChange,
}: TOrganisationEntityDocumentsUploaderProps) {
  const { documents, documentType } = useDocumentRequirements(entityType);

  // Compose the subtitle content with document requirements
  const subtitle = (
    <>
      <Typography variant="body1" sx={(theme) => ({ mt: theme.semantic.spacing.sm })}>
        {DOCUMENT_REQUIREMENTS_INTRO}
      </Typography>
      <DocumentRequirementsList documents={documents} />
      <DocumentRequirementsList
        title={ADDITIONAL_DOCUMENTS_HEADING}
        documents={ADDITIONAL_DOCUMENTS}
      />
    </>
  );

  return (
    <DocumentsUploader
      entityId={entityId}
      documentType={documentType}
      title="Upload Supporting Documents"
      subtitle={subtitle}
      isMultiple
      onUploadingChange={onUploadingChange}
      onUploadedFilesChange={onUploadedFilesChange}
    />
  );
}
